<template>
  <div>
    <h4 class="title">Контактная информация</h4>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group is-empty">
          <input type="text" v-model="email" name="email" class="form-control" placeholder="Email">
          <span class="material-input"></span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group is-empty">
          <input type="text" v-model="phone" name="phone" class="form-control" placeholder="Контактный телефон" v-mask="'+# ### ###-##-##'">
          <span class="material-input"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="form-group is-empty">
          <textarea class="form-control" rows="5" v-model="comment" placeholder="Комментарий"></textarea>
          <span class="material-input"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ContactForm',
  data() {
    return {
      email: null,
      phone: '+7',
      comment: null,
    };
  },
  computed: {
    contactInfo() {
      return {
        email: this.email ? this.email : null,
        phone: this.phone ? this.phone : null,
        comment: this.comment ? this.comment : null,
      };
    },
    ...mapGetters(['reservationCreated']),
  },
  methods: {
    clearForm() {
      this.email = null;
      this.phone = '+7';
      this.comment = null;
    },
  },
  mounted() {
    this.$emit('contactInfoChanged', this.contactInfo);
  },
  watch: {
    contactInfo: {
      // eslint-disable-next-line no-unused-vars
      handler(val, oldVal) {
        this.$emit('contactInfoChanged', this.contactInfo);
      },
      deep: true,
    },
    reservationCreated(v) {
      if (v) this.clearForm();
    },
  },
};
</script>
